import {Box, Grid, IconButton, TextField, Toolbar, Tooltip, Typography,} from '@mui/material';
import {DateRangePicker, LocalizationProvider} from '@mui/lab';
import {FormattedMessage} from 'react-intl';
import {enUS, he} from 'date-fns/locale';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import config from 'config';
import Avatar from '../../../../ui-component/extended/Avatar';
import {pdf, xslx} from '../../../../assets/images';
import ClearIcon from '@mui/icons-material/ClearOutlined';
import {getFile} from '../../../../api/customer/files.api';
import {getCartesetPDF, sendPdfEmail} from '../../../../api/customer/documents.api';
import {parseJSON} from 'date-fns';
import GenerativeLoader from "../../../../ui-component/GenerativeLoader";
import JSDB from "../../../../fromKotlin/nk";
import {Email} from "@mui/icons-material";
import * as React from "react";


export const CartesetFilterBar = ({ range, setRange, cid, debt, loading }: {
    range: any;
    setRange: any;
    cid?: string;
    debt?: number;
    loading?: boolean;
}) =>
{

    return(<Grid container spacing={2} alignItems='center'>
            <Grid item xs={12} md={7}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={config.i18n === 'he' ? he : enUS}>
                    <DateRangePicker
                        mask=''
                        renderInput={(startProps, endProps) => (
                            <>
                                <TextField
                                    size='small'
                                    fullWidth
                                    {...startProps}
                                    InputProps={{
                                        endAdornment: (
                                            <Tooltip title={<FormattedMessage id='clear' />}>
                                                <IconButton size='small'
                                                            onClick={() => setRange((prevRange) => [null, prevRange[1]])}>
                                                    <ClearIcon fontSize='small' />
                                                </IconButton>
                                            </Tooltip>
                                        )
                                    }}
                                />
                                <Box sx={{ mx: 2 }}>
                                    <FormattedMessage id='to' />
                                </Box>
                                <TextField
                                    size='small'
                                    fullWidth
                                    {...endProps}
                                    InputProps={{
                                        endAdornment: (
                                            <Tooltip title={<FormattedMessage id='clear' />}>
                                                <IconButton size='small'
                                                            onClick={() => setRange((prevRange) => [prevRange[0], null])}>
                                                    <ClearIcon fontSize='small' />
                                                </IconButton>
                                            </Tooltip>
                                        )
                                    }}
                                />
                            </>
                        )}
                        startText={<FormattedMessage id='From Date' />}
                        endText={<FormattedMessage id='To Date' />}
                        value={range}
                        onChange={(newValue) => {
                            if (newValue) setRange(newValue);
                        }}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap',
                    gap: 1.5,
                    columnGap: 2,
                    minWidth: 0,
                }}>
                    <Typography variant='h4' sx={{color: 'blue', fontWeight: 700, whiteSpace: 'nowrap'}}>
                        כרטסת
                    </Typography>
                    <Typography variant='h2' sx={{color: 'red', fontWeight: 700, whiteSpace: 'nowrap', lineHeight: 1.2}}>
                        סה''כ חוב : {loading ? '…' : debt} שח
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )}



export default CartesetFilterBar;
